import range from 'lodash/range';

export default {
  version: window.__DATA__.version,
  gitSHA: window.__DATA__.gitSHA,
  enabledFeatures: window.__DATA__.features,
  GoogleAnalyticsID: window.__DATA__.gaID,
  defaultLanguage: 'de',
  availableLanguages: ['de', 'fr', 'it', 'en', 'bg'],
  availableYears: range(1940, 2018).map(y => y.toString()),
  localStorageLanguageField: 'language',
  localStorageFilterField: 'filter',
  colors: {
    blue: '#0053A1',
  },
  availableBodyParts: ['body', 'back', 'shoulder', 'legs', 'hip', 'neck'],
  availableResources: ['ball', 'mat', 'stepper', 'stool', 'towel'],
  availableDimensions: ['strength', 'mobility', 'coordination', 'endurance'],
  sentryDsn: window.__DATA__.sentryDSN,
};



// WEBPACK FOOTER //
// ./src/config.js